var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _rect, _path48, _rect2, _rect3, _rect4, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3Crackers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 1658,
    viewBox: "0 0 370 1658",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303.258 1463.14L324.858 1465.64L306.051 1455.03L369.414 1447.7L306.051 1440.37L324.855 1429.77L303.258 1432.27L350.319 1388.99L294.882 1420.25L303.818 1400.75L287.817 1415.47L300.446 1352.77L273.878 1410.75L269.622 1389.62L265.36 1410.78L238.766 1352.79L251.404 1415.45L235.429 1400.75L244.362 1420.25L188.925 1389L235.983 1432.27L214.389 1429.77L233.193 1440.37L169.83 1447.7L233.193 1455.03L214.389 1465.64L235.989 1463.14L188.925 1506.42L244.362 1475.16L235.429 1494.65L251.427 1479.94L238.798 1542.63L265.363 1484.66L269.622 1505.79L273.878 1484.66L300.446 1542.63L287.817 1479.94L303.818 1494.65L294.879 1475.15L350.319 1506.42L303.258 1463.14Z",
    fill: "#F68712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M238.74 1466.48C251.903 1454.86 255.214 1446.67 248.614 1441.14C248.071 1442.02 247.521 1442.88 246.954 1443.66C240.281 1452.8 232.937 1461.48 225.264 1469.49C216.758 1478.37 209.476 1490.56 199.932 1497.76C207.819 1493.85 215.464 1486.73 223.043 1482.07C229.303 1478.22 235.242 1474.03 241.381 1470.28C235.174 1492.84 229.186 1543.12 228.788 1564.73C250.149 1491.9 258.489 1483.88 265.483 1468C266.059 1468.8 266.683 1469.58 267.276 1470.38C264.654 1452.66 255.638 1451.56 238.74 1466.48",
    fill: "#F9A72B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256.003 1420.8L253.54 1421.38L243.601 1413.57L243.171 1413.46C247.608 1417.45 253.071 1422.67 256.683 1426.36C256.725 1424.72 256.499 1422.87 256.003 1420.8Z",
    fill: "#F9A72B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M255.407 1431.17C254.747 1431.84 254.129 1432.58 253.54 1433.37C254.32 1432.75 254.919 1432 255.407 1431.17Z",
    fill: "#F9A72B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M259.582 1419.94L258.307 1420.25C265.651 1429.25 272.884 1427.47 280.862 1414.92C272.671 1409.83 264.935 1403.71 230.646 1373.37L231.377 1374.43L271.263 1416.62L263.356 1417.84L237.872 1383.85L261.262 1417.75C259.913 1417.42 257.831 1416.94 255.547 1416.41C255.954 1417.06 256.362 1417.62 256.77 1418.2L259.582 1419.94",
    fill: "#F9A72B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M254.586 1416.19C254.026 1416.06 253.456 1415.93 252.883 1415.8L254.913 1417.06L254.586 1416.19",
    fill: "#F9A72B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M304.776 1439.64C312.741 1430.18 319.068 1418.78 326.133 1408.36C332.61 1398.8 340.604 1389.35 345.225 1378.72C333.678 1396.52 317.738 1402.82 303.433 1417.23C293.863 1399.3 288.458 1384.16 283.261 1365.06C284.727 1380 284.121 1395.46 283.597 1410.26C283.791 1409.91 283.979 1409.59 284.173 1409.23C283.96 1409.63 283.795 1410 283.594 1410.39C283.523 1412.43 283.452 1414.45 283.39 1416.45C282.688 1416.03 282.008 1415.62 281.332 1415.21C273.836 1432.84 281.134 1438.84 304.511 1434.61C283.672 1438.38 278.221 1445.45 287.811 1457.1C287.64 1455.94 287.465 1454.79 287.332 1453.64L287.817 1453.68L287.326 1453.28L293.086 1450.94L296.329 1454.41C309.126 1455.63 321.315 1457.56 334.098 1460.77C325.545 1454.73 311.252 1448 304.776 1439.64",
    fill: "#F9A72B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M268.282 1471.72C275.431 1481.25 283.419 1490.34 290.594 1500.05C297.423 1509.3 303.708 1521 310.851 1528.85C303.721 1506.42 292.271 1482.72 288.244 1459.76C275.914 1452.33 269.528 1456.15 268.282 1471.72",
    fill: "#F9A72B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M251.647 1409.3C252.851 1411.79 253.809 1414.06 254.586 1416.19C254.916 1416.27 255.223 1416.34 255.547 1416.41C254.256 1414.37 252.958 1412.01 251.647 1409.3",
    fill: "#FFF200"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M283.594 1410.39L283.597 1410.26C282.675 1411.95 281.765 1413.5 280.862 1414.92L281.332 1415.21C281.979 1413.69 282.727 1412.09 283.594 1410.39Z",
    fill: "#FFF200"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M297.345 1466.34C293.287 1462.98 290.125 1459.91 287.811 1457.1C287.943 1457.99 288.089 1458.87 288.244 1459.76C290.992 1461.42 293.999 1463.57 297.345 1466.34Z",
    fill: "#FFF200"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M231.426 1434.78C239.65 1436.29 245.336 1438.4 248.614 1441.14C250.184 1438.6 251.728 1435.79 253.54 1433.37C249.715 1436.38 242.401 1436.8 231.426 1434.78Z",
    fill: "#FFF200"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M268.078 1480.52C268.004 1477.26 268.075 1474.33 268.282 1471.72C267.949 1471.28 267.606 1470.83 267.275 1470.38C267.709 1473.32 267.987 1476.67 268.078 1480.52Z",
    fill: "#FFF200"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M258.88 1428.67C258.269 1428 257.55 1427.24 256.683 1426.36C256.631 1428.25 256.191 1429.84 255.408 1431.17C256.443 1430.12 257.602 1429.28 258.88 1428.67",
    fill: "#FFF200"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M259.783 1428.23C259.463 1428.34 259.185 1428.53 258.88 1428.67L259.473 1429.32L259.783 1428.23Z",
    fill: "#FFF200"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M256.77 1418.2C256.362 1417.62 255.954 1417.06 255.547 1416.41C255.223 1416.34 254.916 1416.27 254.585 1416.19L254.912 1417.06L256.77 1418.2Z",
    fill: "#FFF200"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M284.173 1409.23C283.979 1409.59 283.791 1409.91 283.597 1410.26L283.594 1410.39C283.794 1410 283.959 1409.63 284.173 1409.23",
    fill: "#FFF200"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M275.92 1450.42C271.428 1452.59 266.237 1451.15 264.321 1447.2C262.405 1443.24 264.492 1438.27 268.985 1436.1C273.477 1433.92 278.668 1435.36 280.584 1439.32C282.5 1443.27 280.412 1448.24 275.92 1450.42ZM304.511 1434.61C281.134 1438.84 273.836 1432.84 281.332 1415.21L280.862 1414.92C272.885 1427.47 265.651 1429.25 258.308 1420.25L256.003 1420.8C256.499 1422.87 256.725 1424.72 256.683 1426.36C257.55 1427.24 258.269 1428 258.881 1428.67C259.185 1428.53 259.463 1428.34 259.783 1428.23L259.473 1429.32L258.881 1428.67C257.602 1429.28 256.443 1430.12 255.408 1431.17C254.919 1432 254.32 1432.75 253.54 1433.37C251.728 1435.79 250.184 1438.6 248.615 1441.14C255.214 1446.67 251.903 1454.86 238.74 1466.48C255.638 1451.56 264.654 1452.66 267.276 1470.38C267.606 1470.83 267.949 1471.28 268.282 1471.72C269.528 1456.15 275.914 1452.33 288.245 1459.76C288.089 1458.87 287.944 1457.99 287.811 1457.1C278.221 1445.45 283.672 1438.38 304.511 1434.61",
    fill: "#FFF200"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M239.073 1440.75L236.649 1441.64L238.319 1442.45L239.073 1440.75Z",
    fill: "#F9A72B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M237.329 1444.69L231.442 1447.81L227.675 1444.92L163.215 1468.51L235.348 1449.15L237.329 1444.69",
    fill: "#F9A72B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M228.655 1371.55L237.873 1383.85L231.377 1374.43L228.655 1371.55Z",
    fill: "#F9A72B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M271.263 1416.62L231.377 1374.43L237.872 1383.85L263.356 1417.84L271.263 1416.62Z",
    fill: "#F9A72B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M246.637 1429.65L174.552 1344.13L240.594 1431.09L246.637 1429.65Z",
    fill: "#F9A72B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M222.694 1397.13L243.601 1413.57C245.74 1414.15 249.333 1414.98 252.883 1415.8L222.694 1397.13",
    fill: "#F9A72B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M256.003 1420.8C255.718 1419.62 255.369 1418.38 254.912 1417.06L252.883 1415.8C249.333 1414.98 245.74 1414.15 243.601 1413.57L253.54 1421.38L256.003 1420.8",
    fill: "#F9A72B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M256.77 1418.2C257.281 1418.94 257.793 1419.62 258.307 1420.25L259.582 1419.94L256.77 1418.2",
    fill: "#F9A72B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M254.913 1417.06C255.369 1418.38 255.719 1419.62 256.003 1420.8L258.308 1420.25C257.793 1419.62 257.282 1418.94 256.77 1418.2L254.913 1417.06Z",
    fill: "#F9A72B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M240.002 1443.27L238.319 1442.45L237.329 1444.69L240.002 1443.27Z",
    fill: "#F9A72B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M200.266 1423.96L227.675 1444.92L236.65 1441.64L200.266 1423.96Z",
    fill: "#F9A72B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M237.329 1444.69L238.319 1442.45L236.649 1441.64L227.675 1444.92L231.442 1447.81L237.329 1444.69",
    fill: "#F9A72B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M321.263 1481.02L296.329 1454.41C293.517 1454.14 290.704 1453.88 287.817 1453.68L321.263 1481.02",
    fill: "#F9A72B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M287.325 1453.28L287.817 1453.68C290.704 1453.88 293.516 1454.14 296.329 1454.41L293.086 1450.94L287.325 1453.28Z",
    fill: "#F9A72B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M260.404 1446.87C261.968 1455.48 260.987 1457.81 253.268 1463.85C262.79 1461.53 265.23 1462.21 271.02 1468.77C269.45 1460.16 270.434 1457.83 278.153 1451.79C268.631 1454.11 266.191 1453.43 260.404 1446.87",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9583 358.368C4.46754 358.368 -10.4556 324.945 7.78487 284.098L120.992 30.6356C139.229 -10.212 169.082 -10.212 187.319 30.6356L300.52 284.098C318.767 324.945 303.84 358.368 267.353 358.368H40.9583Z",
    fill: "#2753A0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M276.583 357.488L193.012 300.748L151.236 0.31057C152.223 0.174627 153.211 0.106694 154.198 0.106694C160.007 0.106694 165.81 2.46329 171.293 7.24395L300.161 343.667C294.766 350.813 286.794 355.672 276.583 357.488",
    fill: "url(#paint0_linear_203_6579)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M273.551 407.663C255.424 401.879 237.238 397.921 219.399 395.374C173.6 388.839 130.048 391.616 95.4828 396.837C71.216 400.501 51.3897 405.362 38.3274 409.042L22.2521 409.139C22.2521 409.139 21.7148 414.192 22.8411 413.807C29.0324 440.452 86.3107 461.037 155.978 460.626C225.111 460.218 281.843 439.286 288.439 412.855C288.872 411.117 289.096 409.356 289.079 407.576L273.551 407.663",
    fill: "#2E3192"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M288.267 344.964C282.778 318.041 225.186 297.155 155.02 297.566C81.3396 297.996 21.7408 321.751 21.909 350.616L22.2521 409.139L38.3274 409.042C51.3897 405.362 71.2161 400.5 95.4828 396.836C130.048 391.616 173.6 388.838 219.399 395.373C237.238 397.921 255.424 401.879 273.551 407.663L289.079 407.576L288.736 349.053L288.717 344.958L288.267 344.964",
    fill: "url(#paint1_linear_203_6579)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M270.334 423.575C270.466 445.005 219.247 462.681 155.939 463.05C92.6376 463.422 41.2108 446.349 41.0911 424.918C40.9648 403.485 92.1813 385.812 155.486 385.44C218.794 385.068 270.211 402.145 270.334 423.575",
    fill: "#351F17"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M268.628 1113.36C269.104 1111 269.366 1108.58 269.356 1106.09L265.482 445.193C265.382 427.896 252.883 413.331 235.723 408.45C228.856 404.98 220.269 401.989 210.389 399.623C194.747 395.869 175.879 393.707 155.534 393.739C155.143 393.739 154.751 393.729 154.36 393.732C134.569 393.852 116.186 396.05 100.745 399.717C87.2199 402.931 75.9377 407.269 68.0441 412.366C54.9462 419.028 46.1108 431.826 46.1949 446.478L50.0689 1107.38C50.0851 1109.86 50.3796 1112.28 50.8845 1114.63C50.399 1116.14 50.1336 1117.67 50.1401 1119.22C50.2016 1129.91 62.2282 1139.52 81.65 1146.48L105.121 1146.34L159.942 1146.02L214.758 1145.7L238.238 1145.56C257.579 1138.38 269.489 1128.62 269.424 1117.93C269.421 1116.39 269.133 1114.86 268.628 1113.36",
    fill: "url(#paint2_linear_203_6579)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M81.65 1146.48C62.2282 1139.52 50.2016 1129.91 50.1401 1119.22C50.1336 1117.67 50.399 1116.14 50.8845 1114.63C50.3796 1112.28 50.0851 1109.86 50.0689 1107.38L46.1949 446.479C46.1108 431.826 54.9462 419.028 68.0441 412.367C75.9377 407.269 87.2199 402.931 100.745 399.717C116.186 396.05 134.569 393.852 154.36 393.733C154.382 393.733 154.402 393.733 154.421 393.733C154.793 393.733 155.162 393.739 155.534 393.739C155.693 393.739 155.845 393.739 156 393.739C176.167 393.739 194.867 395.895 210.389 399.623C220.269 401.99 228.856 404.98 235.723 408.45C252.883 413.331 265.382 427.896 265.482 445.193L269.356 1106.09C269.366 1108.58 269.104 1111 268.628 1113.36C269.133 1114.86 269.421 1116.39 269.424 1117.93C269.489 1128.62 257.579 1138.38 238.238 1145.56L224.739 1145.64C224.739 1144.08 224.739 1142.7 224.739 1141.56C243.436 1135.86 255.09 1127.85 255.042 1119.04C254.941 1102.32 212.716 1088.97 160.347 1088.97C159.748 1088.97 159.14 1088.97 158.538 1088.98C105.331 1089.29 62.2832 1103.25 62.3868 1120.17C62.4418 1129.87 76.6626 1138.43 98.8127 1143.91V1146.38L81.65 1146.48",
    fill: "url(#paint3_linear_203_6579)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M255.042 1119.04C255.139 1135.95 212.094 1149.92 158.897 1150.23C105.69 1150.54 62.484 1137.08 62.3869 1120.17C62.2833 1103.25 105.331 1089.29 158.538 1088.98C211.738 1088.67 254.941 1102.13 255.042 1119.04Z",
    fill: "#BDABAC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M250.2 1120.87C250.284 1134.47 209.878 1145.73 159.943 1146.02C110.014 1146.31 69.4684 1135.53 69.3907 1121.93C69.3131 1108.33 109.726 1097.07 159.655 1096.77C209.586 1096.48 250.123 1107.27 250.2 1120.87Z",
    fill: "#581D4D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M230.976 1126.63C231.053 1140.45 199.268 1151.84 159.975 1152.07C120.688 1152.3 88.7735 1141.28 88.6925 1127.47C88.6084 1113.64 120.393 1102.25 159.68 1102.02C198.977 1101.79 230.898 1112.81 230.976 1126.63Z",
    fill: "#3A122E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M259.874 1117.99L259.806 1106.14C259.816 1108.63 259.576 1111.05 259.149 1113.41C259.608 1114.91 259.867 1116.44 259.874 1117.99",
    fill: "#CC5A48"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M161.778 1220.77C127.002 1220.77 98.813 1213.52 98.813 1199.9C98.813 1198.93 98.813 1194.01 98.813 1192.45V1146.38V1143.91V1140.23V1138.03C98.813 1128.88 103.872 1120.9 111.345 1116.73C110.141 1117.41 109.027 1118.21 107.962 1119.06V1199.72C107.38 1200.12 106.875 1200.53 106.457 1200.95C105.483 1201.91 104.91 1202.92 104.91 1203.96C104.91 1211.25 130.375 1217.16 161.778 1217.16C193.19 1217.16 218.651 1211.25 218.651 1203.96C218.651 1202.64 217.791 1201.38 216.253 1200.18C215.221 1199.38 213.868 1198.6 212.23 1197.87V1116.83L212.179 1116.78C210.826 1116.02 209.424 1115.35 207.923 1114.86C217.373 1117.94 224.283 1126.62 224.717 1136.99C224.729 1137.34 224.739 1137.68 224.739 1138.03C224.739 1138.03 224.739 1138.08 224.739 1138.18C224.739 1138.57 224.739 1139.76 224.739 1141.56C224.739 1142.7 224.739 1144.08 224.739 1145.64C224.739 1162.01 224.739 1199.14 224.739 1199.9C224.739 1213.52 196.55 1220.77 161.778 1220.77M183.976 1191.8C177.157 1191.13 169.655 1190.76 161.778 1190.76C156.946 1190.76 152.259 1190.9 147.783 1191.16V1105.89C132.883 1107.29 120.251 1110.98 112.5 1115.97C122.475 1109.55 140.505 1105.26 161.105 1105.26C180.08 1105.26 196.877 1108.9 207.207 1114.5C201.314 1111.31 193.281 1108.79 183.976 1107.18V1191.8M111.38 1116.71C111.416 1116.69 111.448 1116.68 111.48 1116.66C111.448 1116.68 111.416 1116.69 111.38 1116.71ZM111.584 1116.59C111.594 1116.58 111.607 1116.57 111.616 1116.56C111.603 1116.57 111.594 1116.58 111.584 1116.59ZM111.694 1116.51C111.704 1116.5 111.713 1116.5 111.723 1116.49C111.713 1116.5 111.704 1116.5 111.694 1116.51ZM111.807 1116.43C111.817 1116.43 111.823 1116.42 111.833 1116.41C111.823 1116.42 111.817 1116.43 111.807 1116.43ZM111.94 1116.34C111.943 1116.34 111.95 1116.34 111.953 1116.33C111.95 1116.34 111.943 1116.34 111.94 1116.34ZM112.044 1116.27C112.056 1116.26 112.073 1116.25 112.086 1116.24C112.073 1116.25 112.06 1116.26 112.044 1116.27ZM112.147 1116.2C112.167 1116.19 112.183 1116.18 112.202 1116.17C112.183 1116.18 112.167 1116.19 112.147 1116.2ZM112.251 1116.14C112.286 1116.11 112.322 1116.09 112.357 1116.06C112.322 1116.09 112.286 1116.11 112.251 1116.14ZM112.403 1116.04C112.425 1116.02 112.451 1116.01 112.477 1115.99C112.451 1116.01 112.425 1116.02 112.403 1116.04ZM207.923 1114.86C207.907 1114.85 207.89 1114.85 207.874 1114.84C207.89 1114.85 207.907 1114.85 207.923 1114.86ZM207.777 1114.82C207.738 1114.79 207.696 1114.77 207.654 1114.74C207.696 1114.77 207.738 1114.79 207.777 1114.82ZM207.576 1114.7C207.557 1114.69 207.541 1114.68 207.525 1114.67C207.541 1114.68 207.557 1114.69 207.576 1114.7ZM207.45 1114.63C207.431 1114.62 207.408 1114.61 207.386 1114.6C207.408 1114.61 207.431 1114.62 207.45 1114.63ZM207.327 1114.57C207.295 1114.55 207.262 1114.53 207.227 1114.51C207.262 1114.53 207.295 1114.55 207.327 1114.57Z",
    fill: "url(#paint4_linear_203_6579)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M216.253 1200.18C209.243 1194.73 187.523 1190.76 161.777 1190.76C134.85 1190.76 112.344 1195.1 106.457 1200.95C105.483 1201.91 104.91 1202.92 104.91 1203.96C104.91 1211.25 130.374 1217.16 161.777 1217.16C193.19 1217.16 218.651 1211.25 218.651 1203.96C218.651 1202.64 217.79 1201.38 216.253 1200.18Z",
    fill: "#530709"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M111.345 1116.73C111.358 1116.73 111.371 1116.72 111.38 1116.71C111.367 1116.72 111.358 1116.73 111.345 1116.73ZM111.481 1116.66C111.516 1116.63 111.549 1116.61 111.584 1116.59C111.549 1116.61 111.516 1116.63 111.481 1116.66ZM111.617 1116.56C111.642 1116.55 111.668 1116.53 111.694 1116.51C111.668 1116.53 111.642 1116.55 111.617 1116.56ZM111.723 1116.49C111.749 1116.47 111.778 1116.45 111.808 1116.43C111.778 1116.45 111.752 1116.47 111.723 1116.49ZM111.833 1116.41C111.869 1116.39 111.905 1116.37 111.94 1116.34C111.905 1116.37 111.869 1116.39 111.833 1116.41ZM111.953 1116.33C111.986 1116.31 112.015 1116.29 112.044 1116.27C112.015 1116.29 111.986 1116.31 111.953 1116.33ZM112.086 1116.24C112.108 1116.23 112.128 1116.22 112.147 1116.2C112.128 1116.22 112.108 1116.23 112.086 1116.24ZM112.202 1116.17C112.219 1116.16 112.235 1116.15 112.251 1116.14C112.235 1116.15 112.219 1116.16 112.202 1116.17ZM112.358 1116.07C112.374 1116.06 112.387 1116.05 112.403 1116.04C112.387 1116.05 112.374 1116.06 112.358 1116.07ZM112.477 1115.99C112.484 1115.98 112.494 1115.98 112.5 1115.97C112.494 1115.98 112.484 1115.98 112.477 1115.99Z",
    fill: "url(#paint5_linear_203_6579)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 104.962,
    y: 1104.08,
    width: 45.3747,
    height: 98.1378,
    fill: "url(#pattern0)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M107.962 1199.73V1199.72C114.102 1195.51 129.09 1192.26 147.783 1191.16V1191.17C129.074 1192.27 114.089 1195.53 107.962 1199.73",
    fill: "url(#paint6_linear_203_6579)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 204.32,
    y: 1111.85,
    width: 6.53765,
    height: 4.9199,
    fill: "url(#pattern1)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 181.018,
    y: 1104.08,
    width: 33.0763,
    height: 96.5194,
    fill: "url(#pattern2)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 181.018,
    y: 1189.53,
    width: 33.0763,
    height: 11.0697,
    fill: "url(#pattern3)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M185.999 1650.06C185.999 1654.22 174.193 1657.59 159.625 1657.59C145.055 1657.59 133.258 1654.22 133.258 1650.06V1206.58C133.258 1202.42 145.055 1199.05 159.625 1199.05C174.193 1199.05 185.999 1202.42 185.999 1206.58V1650.06Z",
    fill: "#530709"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M209.822 1203.21C207.586 1260.24 282.141 1288.54 315.382 1332.71C330.422 1352.69 341.726 1380.01 330.15 1402.3C319.337 1423.1 291.882 1437.14 268.169 1448.89C261.615 1452.13 255.553 1444.2 262.058 1440.98C287.021 1428.62 314.932 1414.03 322.243 1390.78C326.289 1377.93 318.77 1362.23 312.925 1350.27C306.252 1336.62 295.174 1324.61 282.212 1313.99C243.876 1282.59 195.896 1249.61 197.709 1203.21C197.942 1197.32 210.052 1197.3 209.822 1203.21Z",
    fill: "#530709"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M46.658 525.665C69.0573 496.434 130.316 438.71 264.787 438.448C261.958 424.193 250.598 412.68 235.724 408.45C228.856 404.98 220.27 401.989 210.389 399.623C202.796 397.798 194.43 396.361 185.514 395.357C121.474 406.916 76.6144 431.47 46.2534 455.832L46.658 525.665",
    fill: "url(#paint7_linear_203_6579)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9424 573.941L47.3502 643.424C70.3838 613.821 132.099 556.971 266.136 557.11L265.845 507.206C157.706 507.132 88.7506 540.622 46.9424 573.941",
    fill: "#FFF200"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M49.71 1046.39L50.0692 1107.38C50.0822 1109.59 50.3475 1111.74 50.7553 1113.84C76.3522 1083.16 139.12 1030.86 268.92 1031.76L268.625 981.851C161.266 981.206 92.1363 1013.52 49.71 1046.39",
    fill: "#FFF200"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0176 928.283L49.4189 996.808C74.0967 966.45 136.586 912.403 268.224 913.096L267.933 863.189C160.373 862.694 91.295 895.3 49.0176 928.283Z",
    fill: "url(#paint8_linear_203_6579)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3281 810.155L48.7294 878.994C72.8829 848.853 135.136 793.91 267.528 794.431L267.237 744.527C159.483 744.151 90.447 777.053 48.3281 810.155Z",
    fill: "#FFF200"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6353 692.046L48.0398 761.212C71.6398 731.334 133.63 675.461 266.832 675.775L266.541 625.868C158.593 625.638 89.6053 658.837 47.6353 692.046Z",
    fill: "url(#paint9_linear_203_6579)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M138.249 1541.85V1564.3H181.009V1541.85H138.249Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M138.249 1498.6V1521.05H181.009V1498.6H138.249Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M138.249 1585.1V1607.55H181.009V1585.1H138.249Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M138.249 1628.35V1650.06L138.356 1650.8H180.902L181.009 1650.06V1628.35H138.249Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M138.249 1455.35V1477.81H181.009V1455.35H138.249Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M138.249 1412.1V1434.56H181.009V1412.1H138.249Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M138.249 1239.1V1261.56H181.009V1239.1H138.249Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M138.249 1368.85V1391.3H181.009V1368.85H138.249Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M138.249 1282.35V1304.81H181.009V1282.35H138.249Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M138.249 1325.6V1348.06H181.009V1325.6H138.249Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M273.551 407.663C255.424 401.879 237.238 397.921 219.399 395.374C173.6 388.839 130.048 391.616 95.4828 396.837C71.216 400.501 51.3897 405.362 38.3274 409.042L22.2521 409.139C22.2521 409.139 21.7148 414.192 22.8411 413.807C29.0324 440.452 86.3107 461.037 155.978 460.626C225.111 460.218 281.843 439.286 288.439 412.855C288.872 411.117 289.096 409.356 289.079 407.576L273.551 407.663",
    fill: "#2E3192"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M288.267 344.964C282.778 318.041 225.186 297.155 155.02 297.566C81.3396 297.996 21.7408 321.751 21.909 350.616L22.2521 409.139L38.3274 409.042C51.3897 405.362 71.2161 400.5 95.4828 396.836C130.048 391.616 173.6 388.838 219.399 395.373C237.238 397.921 255.424 401.879 273.551 407.663L289.079 407.576L288.736 349.053L288.717 344.958L288.267 344.964",
    fill: "url(#paint10_linear_203_6579)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M270.334 423.575C270.466 445.005 219.247 462.681 155.939 463.05C92.6376 463.422 41.2108 446.349 41.0911 424.918C40.9648 403.485 92.1813 385.812 155.486 385.44C218.794 385.068 270.211 402.145 270.334 423.575",
    fill: "#351F17"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M268.628 1113.36C269.104 1111 269.366 1108.58 269.356 1106.09L265.482 445.193C265.385 427.896 252.883 413.334 235.723 408.45C228.856 404.98 220.269 401.989 210.389 399.623C194.747 395.869 175.879 393.707 155.538 393.739C155.143 393.739 154.751 393.729 154.36 393.732C134.569 393.852 116.186 396.05 100.745 399.717C87.2199 402.931 75.9377 407.269 68.0441 412.366C54.9462 419.028 46.1108 431.826 46.1949 446.478L50.0689 1107.38C50.0851 1109.86 50.3796 1112.28 50.8845 1114.63C50.399 1116.14 50.1336 1117.67 50.1401 1119.22C50.2016 1129.91 62.2282 1139.52 81.65 1146.48L105.117 1146.34L159.942 1146.02L214.758 1145.7L238.238 1145.56C257.579 1138.38 269.489 1128.62 269.428 1117.94C269.421 1116.39 269.133 1114.86 268.628 1113.36",
    fill: "url(#paint11_linear_203_6579)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M268.628 1113.36C269.104 1111 269.366 1108.58 269.356 1106.09L265.482 445.193C265.385 427.896 252.883 413.334 235.723 408.45C228.856 404.98 220.269 401.989 210.389 399.623C194.747 395.869 175.879 393.707 155.538 393.739C155.143 393.739 154.751 393.729 154.36 393.732C134.569 393.852 116.186 396.05 100.745 399.717C87.2199 402.931 75.9377 407.269 68.0441 412.366C54.9462 419.028 46.1108 431.826 46.1949 446.478L50.0689 1107.38C50.0851 1109.86 50.3796 1112.28 50.8845 1114.63C50.399 1116.14 50.1336 1117.67 50.1401 1119.22C50.2016 1129.91 62.2282 1139.52 81.65 1146.48L105.117 1146.34L159.942 1146.02L214.758 1145.7L238.238 1145.56C257.579 1138.38 269.489 1128.62 269.428 1117.94C269.421 1116.39 269.133 1114.86 268.628 1113.36",
    fill: "url(#paint12_linear_203_6579)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M46.658 525.665C69.0573 496.434 130.316 438.71 264.787 438.448C261.958 424.193 250.598 412.68 235.724 408.45C228.856 404.98 220.27 401.989 210.389 399.623C202.796 397.798 194.43 396.361 185.514 395.357C121.474 406.916 76.6144 431.47 46.2534 455.832L46.658 525.665",
    fill: "url(#paint13_linear_203_6579)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9424 573.941L47.3502 643.424C70.3838 613.821 132.099 556.971 266.136 557.11L265.845 507.206C157.706 507.132 88.7506 540.622 46.9424 573.941",
    fill: "#FFF200"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M49.71 1046.39L50.0692 1107.38C50.0822 1109.59 50.3475 1111.74 50.7553 1113.84C76.3522 1083.16 139.12 1030.86 268.92 1031.76L268.625 981.851C161.266 981.206 92.1363 1013.52 49.71 1046.39",
    fill: "#FFF200"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0176 928.283L49.4189 996.808C74.0967 966.45 136.586 912.403 268.224 913.096L267.933 863.189C160.373 862.694 91.295 895.3 49.0176 928.283Z",
    fill: "url(#paint14_linear_203_6579)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3281 810.155L48.7294 878.994C72.8829 848.853 135.136 793.91 267.528 794.431L267.237 744.527C159.483 744.151 90.447 777.053 48.3281 810.155Z",
    fill: "#FFF200"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6353 692.046L48.0398 761.212C71.6398 731.334 133.63 675.461 266.832 675.775L266.541 625.868C158.593 625.638 89.6053 658.837 47.6353 692.046Z",
    fill: "url(#paint15_linear_203_6579)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_203_6579",
    transform: "scale(0.0344828 0.015873)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_203_6579",
    transform: "scale(0.25 0.333333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_203_6579",
    transform: "scale(0.047619 0.016129)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3_203_6579",
    transform: "scale(0.047619 0.142857)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_203_6579",
    x1: 284.642,
    y1: 147.456,
    x2: 53.3492,
    y2: 252.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A4299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860215,
    stopColor: "#1381C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865592,
    stopColor: "#1381C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#294599"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_203_6579",
    x1: 21.9252,
    y1: 353.743,
    x2: 288.755,
    y2: 352.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2057AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623656,
    stopColor: "#24265D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629032,
    stopColor: "#2E3192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ADEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_203_6579",
    x1: 46.1949,
    y1: 770.106,
    x2: 269.426,
    y2: 770.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A72B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860215,
    stopColor: "#008E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865592,
    stopColor: "#00A650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CD41F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_203_6579",
    x1: 46.1949,
    y1: 770.106,
    x2: 269.426,
    y2: 770.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860215,
    stopColor: "#51ADE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865592,
    stopColor: "#00ADEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F318A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_203_6579",
    x1: 98.813,
    y1: 1163.01,
    x2: 224.738,
    y2: 1163.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634409,
    stopColor: "#530709"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645161,
    stopColor: "#AC1318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_203_6579",
    x1: 147.785,
    y1: 1152.81,
    x2: 108.409,
    y2: 1152.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#741936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#734B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_203_6579",
    x1: 147.787,
    y1: 1152.81,
    x2: 108.409,
    y2: 1152.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#911113"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93430C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_203_6579",
    x1: 46.2534,
    y1: 460.513,
    x2: 264.786,
    y2: 460.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860215,
    stopColor: "#DCDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865592,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFCECE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_203_6579",
    x1: 49.0176,
    y1: 929.995,
    x2: 268.222,
    y2: 929.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860215,
    stopColor: "#DCDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865592,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFCECE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_203_6579",
    x1: 47.6353,
    y1: 693.538,
    x2: 266.834,
    y2: 693.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860215,
    stopColor: "#DCDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865592,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFCECE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_203_6579",
    x1: 21.9252,
    y1: 353.743,
    x2: 288.755,
    y2: 352.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2057AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623656,
    stopColor: "#24265D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629032,
    stopColor: "#2E3192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ADEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_203_6579",
    x1: 46.1949,
    y1: 770.106,
    x2: 269.426,
    y2: 770.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A72B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860215,
    stopColor: "#008E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865592,
    stopColor: "#00A650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CD41F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_203_6579",
    x1: 46.1949,
    y1: 770.106,
    x2: 269.426,
    y2: 770.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860215,
    stopColor: "#51ADE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865592,
    stopColor: "#00ADEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F318A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_203_6579",
    x1: 46.2534,
    y1: 460.513,
    x2: 264.786,
    y2: 460.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860215,
    stopColor: "#DCDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865592,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFCECE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_203_6579",
    x1: 49.0176,
    y1: 929.995,
    x2: 268.222,
    y2: 929.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860215,
    stopColor: "#DCDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865592,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFCECE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_203_6579",
    x1: 47.6353,
    y1: 693.538,
    x2: 266.834,
    y2: 693.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860215,
    stopColor: "#DCDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865592,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFCECE"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_203_6579",
    width: 29,
    height: 63,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAA/CAYAAAAc98MyAAAABHNCSVQICAgIfAhkiAAAAGZJREFUWIXtzcEJQ1EIRNFrakib6TwlOJrFf5ukgfDhCoLDIKfer+cukIFpSGC7mD65iw2kYQLzk9OwqavL+T/3pL7zXPvgDyMqKioqKioqKioqKioqKioqKioqKioqKioqKnoj9ANkyTlfb7+G7gAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_203_6579",
    width: 4,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAABHNCSVQICAgIfAhkiAAAAB9JREFUCJlj3CWv/5/z/z8GLoa/DDz//zEwMaABDAEAMF8HI76O1koAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_203_6579",
    width: 21,
    height: 62,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAA+CAYAAADEfFBjAAAABHNCSVQICAgIfAhkiAAAAFdJREFUWIXtzLENgFAMA9FzCCsgsf8KzPehiNiACl0ax5L1ch3nXYQO7BW6oMn8gS2hmSygE+qGepNQC2A6a3afn6ioqKioqKioqKioqKioqKioqOg/0AcsbQemG/xujgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image3_203_6579",
    width: 21,
    height: 7,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAHCAYAAADnCQYGAAAABHNCSVQICAgIfAhkiAAAAEBJREFUKJHtjLsNgFAQwxwX7w6xJfvv8Cj4TUCBRKQoceNsyzoBhqENlbN6cydUpLz+wc2zjQxCTZEX8ks/It0B96IDOEj0OwwAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Crackers);
export default __webpack_public_path__ + "static/media/3crackers.2a0311e23bea7d690c67f4ec334a2b11.svg";
export { ForwardRef as ReactComponent };